import { DEFAULT_GRID_VIEW_STATE } from '../constants';
import { createReducer, on } from '@ngrx/store';
import {
  GRID_VIEW_ACTIONS,
  GRID_VIEW_DATA_ACTIONS,
  GRID_VIEW_TABLE_ACTIONS,
} from '../actions';
import { GridViewsState } from '../types';
import { getUpdatedViews } from '../utils';

export const gridViewsReducer = createReducer(
  DEFAULT_GRID_VIEW_STATE,
  on(
    GRID_VIEW_ACTIONS.onGetGridViewsSuccess,
    (state: GridViewsState, { grid, grid_type }) => ({
      ...state,
      customViews: {
        [grid_type]: grid,
      },
      gridType: grid_type,
    }),
  ),

  on(
    GRID_VIEW_ACTIONS.onSaveGridViewSuccess,
    (state: GridViewsState, { gridView, grid_type }) => {
      const computeData = () => {
        if (state.customViews[grid_type]) {
          return [...state.customViews[grid_type]!.data, { ...gridView }];
        }
        return [{ ...gridView }];
      };
      const updatedData = computeData();
      return {
        ...state,
        customViews: {
          ...state.customViews,
          [grid_type]: {
            data: updatedData,
            total: updatedData.length,
          },
        },
        gridType: grid_type,
      };
    },
  ),

  on(
    GRID_VIEW_ACTIONS.onSaveGridViewFailure,
    (state: GridViewsState, { errorHandler, grid_type }) => ({
      ...state,
      customViews: {
        ...state.customViews,
        [grid_type]: {
          ...state.customViews[grid_type],
          error: errorHandler,
        },
      },
    }),
  ),

  on(
    GRID_VIEW_ACTIONS.onUpdateGridViewSuccess,
    (state: GridViewsState, { gridView, grid_type }) => {
      const updatedData = state.customViews[grid_type]!.data;

      return {
        ...state,
        customViews: {
          ...state.customViews,
          [grid_type]: {
            data: updatedData.map((v) =>
              v.id === gridView.id! ? gridView : v,
            ),
            total: updatedData.length,
          },
        },
        gridType: grid_type,
      };
    },
  ),
  on(
    GRID_VIEW_ACTIONS.onBulkUpdateGridViewSuccess,
    (state: GridViewsState, { grid_type, grid_views }) => {
      const updatedData = getUpdatedViews(
        state.customViews[grid_type]!.data,
        grid_views,
      );
      return {
        ...state,
        customViews: {
          ...state.customViews,
          [grid_type]: {
            ...state.customViews[grid_type],
            data: updatedData,
            total: updatedData.length,
          },
        },
      };
    },
  ),

  on(
    GRID_VIEW_DATA_ACTIONS.setCustomViewSelection,
    (state: GridViewsState, { selectedView }) => ({
      ...state,
      selectedView: selectedView,
    }),
  ),

  on(
    GRID_VIEW_DATA_ACTIONS.setCustomFilters,
    (state: GridViewsState, { filters, sortBy }) => ({
      ...state,
      customFilters: {
        filters: filters || {},
        sortBy: sortBy,
      },
    }),
  ),

  /**
   * Saving Default Table Headers
   * */
  on(
    GRID_VIEW_TABLE_ACTIONS.saveDefaultTableHeaders,
    (state: GridViewsState, { headers }) => ({
      ...state,
      defaultHeaders: headers,
    }),
  ),
);
